import flatpickr from "flatpickr";
import {French} from "flatpickr/dist/l10n/fr";


export function date_picker_init(){
    flatpickr(".flatpickr_time", {
        enableTime: true,
        locale: French,
        allowInput: true,
        monthSelectorType: "static",
        dateFormat: "Y-m-d H:i", // Format de soumission
        altInput: true,
        altFormat: "d-m-Y H:i", // Format d'affichage
    });
    flatpickr('.flatpickr', {
        locale: French,
        allowInput: true,
        monthSelectorType: "static",
        dateFormat: "Y-m-d", // Format de soumission
        altInput: true,
        altFormat: "d-m-Y", // Format d'affichage
    })
}
